import { ContentfulProductBlock } from '@jbhi-fi/apis/src/contentful/types';
import { ThemeTransformer } from './ThemeTransformer';
import React from 'react';
import { TabsBlockProps } from '../../TabsBlock/TabsBlock';
import { ListingBlockHeading } from '../../ListingBlock/ListingBlockHeading';
import { CarouselTransformer, ToProductCarouselBaseOptions } from './CarouselTransformer/CarouselTransformer';
import { ContentBlockProps } from '../../ContentBlock';

export abstract class ProductBlockTransformer {
  static toContentBlockProps = (entry?: ContentfulProductBlock): Partial<ContentBlockProps> => {
    const theme = ThemeTransformer.toContentThemeVariables(entry?.fields?.theme);

    return {
      style: { backgroundColor: theme?.palette?.background },
    };
  };

  static toTabsBlockProps = (
    entry?: ContentfulProductBlock,
    options: ToProductCarouselBaseOptions = {}
  ): TabsBlockProps => {
    return {
      testId: options?.testId,
      heading: <ListingBlockHeading heading={entry?.fields?.heading} />,
      palette: ThemeTransformer.toContentThemePalette(entry?.fields?.theme),
      tabs:
        (entry?.fields?.productCarousel
          ?.filter(carousel => carousel?.fields)
          ?.map(carousel => {
            const { Component, transformer } = CarouselTransformer.toContentEntryProps(carousel, {
              ...options,
              shouldHideHeading: true,
            });
            const props = transformer?.(carousel);
            if (!transformer || !Component || !props) {
              return null;
            }
            return {
              label: carousel?.fields?.heading ?? '',
              contents: <Component {...props} />,
            };
          })
          .filter(Boolean) as TabsBlockProps['tabs']) ?? [],
    };
  };
}
